import {TableSettings} from "../../../tableSettings";

export const batchRecognitionReportTable: TableSettings = {
  tableVersion: 10028,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.2, headerFilterType: 'None', },
    { Header: 'Select', accessor: 'selected', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType: 'None', },
    { Header: 'Recog Date', accessor: 'recogDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7, headerFilterType:'Date', },
    { Header: 'Bill First', accessor: 'firstDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7, headerFilterType:'Date', },
    //{ Header: 'ETD/ETA', accessor: 'etdeta', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7, headerFilterType:'Date', },
    { Header: 'OP Type', accessor: 'mblType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.5, headerFilterType:'TextSelect', },
    { Header: 'BR', accessor: 'branch', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: '+', accessor: 'closed', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: 'Ref. #', accessor: 'mblRefNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11, headerFilterType:'TextBegin', },

    { Header: 'Manifest(s)', accessor: 'hblCnt', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, headerFilterType:'TextSelect', },
    { Header: 'Customer', accessor: 'hblCustomer', resizable: false, sortable: false, visible: true, initialWidthPercentage: 18.9, headerFilterType:'TextBegin', },

    { Header: 'Def. Sales', accessor: 'defSales', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.4, headerFilterType:'Number', },
    { Header: 'Def. Cost', accessor: 'defCost', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.4, headerFilterType:'Number', },
    //{ Header: 'Def. Agent Sales', accessor: 'defASales', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },
    //{ Header: 'Def. Agent Cost', accessor: 'defACost', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },

    { Header: 'Inv', accessor: 'invPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: 'Bil', accessor: 'billPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    //{ Header: 'CrDb', accessor: 'crDbPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },

    { Header: 'Est. Margin', accessor: 'estMargin', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.4, headerFilterType:'Number', },

    //{ Header: 'Prep. By', accessor: 'hblPrepBy', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'TextBegin', },
    //{ Header: 'Salesperson', accessor: 'hblSalesperson', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'TextBegin', },

    { Header: 'Status', accessor: 'status', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, headerFilterType:'None', },
    { Header: 'View Detail', accessor: 'action', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.7, headerFilterType:'None', },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.50, headerFilterType:'None', },
  ]
};



export const CompanyAddressLabelReportTable: TableSettings = {
  tableVersion: 10010,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: 'Company Name',
      accessor: 'text',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 70,
    },
    {
      Header: 'Count',
      accessor: 'intValue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 19,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    }
  ]
};

export const periodClosingReportTable: TableSettings = {
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Date',
      accessor: 'date',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23,
    },
    {
      Header: 'Closed Period',
      accessor: 'closedPeriod',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23,
    },
    {
      Header: 'User',
      accessor: 'userId',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24,
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.00,
    },
  ]
};

export const customerPaymentList: TableSettings = {
  tableVersion: 10055,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const agentPaymentList: TableSettings = {
  tableVersion: 10052,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const billPaymentList: TableSettings = {
  tableVersion: 10055,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const ccPaymentList: TableSettings = {
  tableVersion: 10052,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const customerPaymentContainerDetails1: TableSettings = {
  tableVersion: 1022,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '65px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const customerPaymentContainerDetails2: TableSettings = {
  tableVersion: 1045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.50,
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.52,
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.53,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.38,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const customerPaymentContainerDetails3: TableSettings = {
  tableVersion: 1016,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, 
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10, 
    },
    {
      Header: 'Customer',
      accessor: 'billToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Received From',
      accessor: 'paidToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Deposit Amount',
      accessor: 'totalAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const customerPaymentContainerDetails4: TableSettings = {
  tableVersion: 1013,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '328px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Account Code',
      accessor: 'glNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.28,
    },
    {
      Header: 'Account Description',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.08,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30.68,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.66,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.66,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const agentPaymentContainerDetails1: TableSettings = {
  tableVersion: 1022,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '65px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const agentPaymentContainerDetails2: TableSettings = {
  tableVersion: 1043,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.50,
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.52,
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.53,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.38,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const agentPaymentContainerDetails3: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Customer',
      accessor: 'billToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Received From',
      accessor: 'paidToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Deposit Amount',
      accessor: 'totalAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const agentPaymentContainerDetails4: TableSettings = {
  tableVersion: 1013,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '328px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Account Code',
      accessor: 'glNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.28,
    },
    {
      Header: 'Account Description',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.08,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30.68,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.66,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.66,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const billPaymentContainerDetails1: TableSettings = {
  tableVersion: 1022,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '66px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const billPaymentContainerDetails2: TableSettings = {
  tableVersion: 1045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.77,
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
    },
    {
      Header: 'B',
      accessor: 'block',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11,
    },
    {
      Header: 'Vendor',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.53,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.77,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.51,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.4,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.4,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.4,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.39,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.77,
    },
  ]
};

export const billPaymentContainerDetails3: TableSettings = {
  tableVersion: 1030,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5, //2.63,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, //8,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10, //11.07,
    },
    {
      Header: 'Vendor',
      accessor: 'billToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //18,
    },
    {
      Header: 'Pay To',
      accessor: 'paidToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //18,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //17.6,
    },
    {
      Header: 'Paid Amount',
      accessor: 'totalAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6, //7,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4, //5,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, //8,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const billPaymentContainerDetails4: TableSettings = {
  tableVersion: 1011,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '328px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Account Code',
      accessor: 'glNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.70,
    },
    {
      Header: 'Account Description',
      accessor: 'glDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.5,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27.34,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.85,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.89,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.70,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.02,
    },
  ]
};

export const ccPaymentContainerDetails2: TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '229px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.58,
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.58,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.85,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.78,
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.85,
    },
    {
      Header: 'B',
      accessor: 'block',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.06,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.70,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.70,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.04,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.89,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.89,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.89,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.04,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.02,
    },
  ]
};

export const ccPaymentContainerDetails3: TableSettings = {
  tableVersion: 1045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Accrual Date',
      accessor: 'accrualDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.7,
    },
    {
      Header: 'CC Ref. #',
      accessor: 'ccRefNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.94,
    },
    {
      Header: 'Vendor',
      accessor: 'billToName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.91,
    },

    {
      Header: 'Credit Card',
      accessor: 'creditCardName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.49,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.04,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Paid Amount',
      accessor: 'totalAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.7,
    },
  ]
};

export const customerPaymentMemoList: TableSettings = {
  tableVersion: 1002,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'customerName',
      Header: 'Customer',
      visible: true,
      width: 200,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      defaultColumnFocus: true
    },
    {
      accessor: 'contact',
      Header: 'Contact',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'phone',
      Header: 'Phone',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'followUp',
      Header: 'Follow Up',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'currency',
      Header: 'CUR',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'lastPaidAmt',
      Header: 'Last Paid Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'checkNo',
      Header: 'Paid Check #',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'lastPaidDate',
      Header: 'Paid Date',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'salesRep',
      Header: 'Sales Rep',
      visible: true,
      width: 95,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'groupId',
      Header: 'Group',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'terms',
      Header: 'Terms',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'avgAging',
      Header: 'Avg Aging',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'currentBal',
      Header: 'Current Balance',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'curCnt',
      Header: 'Current Count',
      visible: true,
      width: 70,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'pastDue',
      Header: 'Past Due Amount',
      visible: true,
      width: 90,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'pastDueCnt',
      Header: 'Past Due Count',
      visible: true,
      width: 90,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days15',
      Header: '15 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days30',
      Header: '30 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days45',
      Header: '45 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days60',
      Header: '60 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days90',
      Header: '90 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'over90',
      Header: 'Over',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'balance',
      Header: 'Total Balance',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'memo',
      Header: 'Last Memo Title',
      visible: true,
      width: 300,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const generalInvoiceList: TableSettings = {
  tableVersion: 1013,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
  ]
};

export const acGeneralInvoiceTable: TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '320px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Billing Code *',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27.63,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 36.40,
    },
    {
      Header: 'CUR',
      accessor: 'cur',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    /*{
      Header: 'Del',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.07,
    },*/
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ],
};

export const generalBillList: TableSettings = {
  tableVersion: 1016,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,
  headersColor: 'gray',
  alternateRows: true,
  columns: [
  ]
};

export const acGeneralBillTable: TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '320px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Billing Code *',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27.63,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 36.40,
    },
    {
      Header: 'CUR',
      accessor: 'cur',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    /*{
      Header: 'Del',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.07,
    },*/
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ],
};

export const depositCheckClearTable: TableSettings = {
  tableVersion: 1003,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'clearDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'bank',
      Header: 'Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'depositAmount',
      Header: 'Deposit Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'withdrawalAmount',
      Header: 'Clear Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'autoWithdrawalAmount',
      Header: 'Clear Amount (Auto)',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'void',
      Header: 'V',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'batchNo',
      Header: 'Batch #',
      visible: true,
      width: 160,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const depositClearTable: TableSettings = {
  tableVersion: 10037,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Received From', accessor: 'receivedFromName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Customer', accessor: 'customerName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Check #', accessor: 'checkNo', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Deposit', accessor: 'isSelected', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const checkClearTable: TableSettings = {
  tableVersion: 10039,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Vendor', accessor: 'customerName', resizable: true, sortable: false, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Check #', accessor: 'checkNo', resizable: true, sortable: false, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: false, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: false, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Check', accessor: 'isSelected', resizable: true, sortable: false, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const creditCardClearList: TableSettings = {
  tableVersion: 1004,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'clearDate',
      Header: 'Clear Date',
      visible: true,
      width: 85,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'bank',
      Header: 'Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'depositAmount',
      Header: 'Deposit Amount',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'withdrawalAmount',
      Header: 'Withdrawal Amount',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'void',
      Header: 'Void',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'batchNo',
      Header: 'Batch #',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 200,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const creditCardClearTable: TableSettings = {
  tableVersion: 10037,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Vendor', accessor: 'vendorName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 33.33, },
    { Header: 'CC Ref. #', accessor: 'ccRefNo', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CC Clear', accessor: 'isSelected', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const bankReconList: TableSettings = {
  tableVersion: 10040,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
  ]
};

export const bankReconTable: TableSettings = {
  tableVersion: 1010,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '455px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, },
    { Header: 'Date', accessor: 'postDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15, },
    { Header: 'Type', accessor: 'paymentType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.5, },
    { Header: 'Amount (USD)', accessor: 'amount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15, },
    { Header: 'Customer', accessor: 'mDesc', resizable: false, sortable: false, visible: true, initialWidthPercentage: 22, },
    { Header: 'Received From', accessor: 'mDesc2', resizable: false, sortable: false, visible: true, initialWidthPercentage: 22, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.5, },
  ]
};

export const bankTransferList: TableSettings = {
  tableVersion: 1011,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'postDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'fBankName',
      Header: 'From Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'fCurrency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tBankName',
      Header: 'To Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tCurrency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tAmount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2Id',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1Id',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const checkClearList: TableSettings = {
  tableVersion: 1002,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'clearDate',
      Header: 'Check Clear',
      visible: true,
      width: 85,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'bank',
      Header: 'Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'checkClearAmount',
      Header: 'Check Clear Amount',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const checkClearTable2: TableSettings = {
  tableVersion: 1007,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '390px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.42,
    },
    {
      Header: 'Bank Date',
      accessor: 'bankDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Clear',
      accessor: 'clear',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.85,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.70,
    },
    {
      Header: 'Bank Amount',
      accessor: 'bankAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.70,
    },
    {
      Header: 'Accrual Date',
      accessor: 'accrualDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Deposit Date',
      accessor: 'depositDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Pay To',
      accessor: 'payTo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.05,
    },
    /*{
      Header: 'No of Items',
      accessor: 'noOfItems',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.09,
    },*/
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Check Clear',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.61,
    },
  ]
};

export const prepaidExpenseAdjustmentList: TableSettings = {
  tableVersion: 1009,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const prepaidExpenseAdjustmentTable: TableSettings = {
  tableVersion: 10050,
  overflowX: 'hidden',
  // overflowY: 'scroll',
  overflowY: 'hidden',
  height: '65px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Account Code',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.3,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 37.76,
    },
    {
      Header: 'Balance',
      accessor: 'expense',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
    // {
    //   Header: '',
    //   accessor: 'scroll',
    //   resizable: false,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 1.75,
    // },
  ]
};

export const paymentPrepTable: TableSettings = {
  tableVersion: 10019,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '360px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'lightgray',
  

  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Vendor',
      accessor: 'vendorName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.57,
    },
    {
      Header: 'Description',
      accessor: 'desc',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 28.31,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Amount',
      accessor: 'amtDesc',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Advance Payment',
      accessor: 'hasAdvance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.2,
    },
    {
      Header: 'Bank & Account',
      accessor: 'bankAndAcct',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.77,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.8,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const paymentPrepList: TableSettings = {
  tableVersion: 1004,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'void',
      Header: 'V',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const payrollSummaryList: TableSettings = {
  tableVersion: 1009,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payrollDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'refNo',
      Header: 'Ref. #',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'grossAmt',
      Header: 'Gross Salary',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'payableFedTax',
      Header: 'Payroll Tax (Fed)',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'fedTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payableStateTax',
      Header: 'Payroll Tax (State)',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'stateTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payableNetSalary',
      Header: 'Net Salary',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'netSalaryPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'addTaxAmt',
      Header: 'Additional Tax',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'addTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'addPayAmt',
      Header: 'Salary Deduction',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'addPayPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    // {
    //   accessor: 'voidInputDate',
    //   Header: 'Void Date',
    //   visible: true,
    //   width: 75,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'date'
    // },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'modifiedAt',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'modifiedBy',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'createdBy',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const payroll2List: TableSettings = {
  tableVersion: 1012,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
  ]
};

export const payrollSummaryAmountsTable: TableSettings = {
  tableVersion: 10042,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '200px',
  useStorage: false,
  flexResizer: false,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Department',
      accessor: 'departmentName',
      resizable: true,
      sortable: false,
      visible: true,
      width: 110,
    },
    {
      Header: 'Gross Salaries & Wages',
      accessor: 'grossAmt',
      resizable: true,
      sortable: false,
      visible: true,
      width: 140,
    },
    // {
    //   Header: 'Federal Payroll Tax (Corporate)',
    //   accessor: 'fedPRTaxAmt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   width: 140,
    // },
    // {
    //   Header: 'State Payroll Tax (Corporate)',
    //   accessor: 'stePRTaxAmt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   width: 140,
    // },
    // {
    //   Header: 'MEDICAL INSURANCE (Withholding)',
    //   accessor: 'expOption1Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: 'DENTAL INSURANCE (Withholding)',
    //   accessor: 'expOption2Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '401K PLAN (Withholding)',
    //   accessor: 'expOption3Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '(*) (Withholding)',
    //   accessor: 'expOption4Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '',
    //   accessor: 'scroll',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 1.75,
    // },
  ]
};

export const payrollSummaryByEntityTable: TableSettings = {
  tableVersion: 1004,
  overflowX: 'hidden',
  overflowY: 'hidden',
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
    },
    {
      Header: 'Payable',
      accessor: 'payable',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Entity',
      accessor: 'entity',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27,
    },
    {
      Header: 'Corporate',
      accessor: 'corporate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Withholding',
      accessor: 'withholding',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Total',
      accessor: 'total',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Paid',
      accessor: 'paid',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.5,
    }
  ]
};

export const payroll2GroupTable: TableSettings = {
  tableVersion: 10005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '100px',
  useStorage: false,
  flexResizer: false,
  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Payroll Group',
      accessor: 'groupName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Gross Salary',
      accessor: 'salaryAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Detail',
      accessor: 'isView',
      resizable: false,
      sortable: false,
      visible: true,
      width: 60,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
  },
  ]
};

export const payroll2AmountsTable: TableSettings = {
  tableVersion: 10051,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '430px',
  useStorage: false,
  flexResizer: false,
  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Group',
      accessor: 'groupName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 60,
    },
    {
      Header: 'Items',
      accessor: 'billingCode',
      resizable: false,
      sortable: false,
      visible: true,
      width: 160,
    },
    {
      Header: 'Withholding',
      accessor: 'withholdAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Corporate',
      accessor: 'corporateAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 140,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
    },
  ]
};

export const payroll2ByEntityTable: TableSettings = {
  tableVersion: 1019,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '200px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Items',
      accessor: 'itemName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 180,
    },
    {
      Header: 'Withholding',
      accessor: 'withholdAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Corporate',
      accessor: 'corporateAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Amount',
      accessor: 'totalAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Payable To',
      accessor: 'payableEntityName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 120,
    },
    {
      Header: 'Bank',
      accessor: 'bank',
      resizable: false,
      sortable: false,
      visible: true,
      width: 150,
    },
    {
      Header: 'ETF Ref #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      width: 100,
    },
    {
      Header: 'Pay Date',
      accessor: 'paidDate',
      resizable: false,
      sortable: false,
      visible: true,
      width: 70,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      width: 50,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
    },
  ]
};

export const depreciationAdjustmentList: TableSettings = {
  tableVersion: 1007,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Adjust Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const depreciationAdjustmentTable: TableSettings = {
    tableVersion: 10046,
    overflowX: 'hidden',
    overflowY: 'scroll',
    height: '525px',
    useStorage: true,
    flexResizer: true,
  
    headersColor: 'gray',
    columns: [
        {
            Header: '#',
            accessor: 'indicator',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2.63,
        },
        {
            Header: 'Account Code',
            accessor: 'glDescription',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 17.54,
        },
        {
            Header: 'BR',
            accessor: 'branch',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 5.26,
        },
        {
            Header: 'Description',
            accessor: 'description',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 41.23,
        },
        {
            Header: 'Expense',
            accessor: 'expense',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: 'Balance',
            accessor: 'balance',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: 'Depreciation Amount',
            accessor: 'adjustmentAmount',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: '',
            accessor: 'scroll',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
        },
    ]
};

export const amortizationAdjustmentList: TableSettings = {
  tableVersion: 1008,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorName',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'accountName',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const amortizationAdjustmentTable: TableSettings = {
  tableVersion: 10048,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '525px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Account Code',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.54,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 41.23,
    },
    {
      Header: 'Expense',
      accessor: 'expense',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Amortization Amount',
      accessor: 'adjustmentAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const badDebtProcessingList: TableSettings = {
  tableVersion: 1008,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'entity',
      Header: 'Entity',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'currency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const badDebtProcessingTable: TableSettings = {
  tableVersion: 1013,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '525px',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'paymentDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.56,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 50,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const salesTaxReturnTable: TableSettings = {
  tableVersion: 1010,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '400px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
    {
      Header: 'Date',
      accessor: 'invoiceDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 38,
    },
    {
      Header: 'Invoice/Bill/CrDb #',
      accessor: 'invoiceNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18,
    },
    {
      Header: 'Type',
      accessor: 'type',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Recovered Amount',
      accessor: 'receivedAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Paid Amount',
      accessor: 'paidAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.25,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const accountingJournalList: TableSettings = {
  tableVersion: 10044,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    // { accessor: 'status', Header: 'S', visible: true, width: 30, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor: 'type', Header: 'Type', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'postDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date'},
    // { accessor: 'branch', Header: 'BR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'seq', Header: 'Seq', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'entity', Header: 'Entity', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor: 'description', Header: 'Description', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'remark', Header: 'Remark', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'accountNo', Header: 'Account No', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'subCode', Header: 'Sub Code', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'currency', Header: 'CUR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'fDebit', Header: 'Debit', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'fCredit', Header: 'Credit', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'exRate', Header: 'Ex. Rate', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'debit', Header: 'Debit (USD)', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'credit', Header: 'Credit (USD)', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'jourType', Header: 'Journal Type', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'updateDate', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date'},
    // { accessor: 'updateBy', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
  ]
};

export const journalTable: TableSettings = {
  tableVersion: 10047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '400px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.63, },
    { Header: 'Account Code', accessor: 'glFull', resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.03, },
    { Header: 'Sub Code', accessor: 'subCode', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Ent.Type', accessor: 'comType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.64, },
    { Header: 'Transaction Entity (Customer)', accessor: 'comName', resizable: false, sortable: false, visible: true, initialWidthPercentage: 13.15, },
    { Header: 'Description', accessor: 'mDesc', resizable: true, sortable: false, visible: true, initialWidthPercentage: 17.17, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.5, },
    { Header: 'Debit', accessor: 'fDebit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Credit', accessor: 'fCredit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Ex. Rate', accessor: 'exRate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.0, },
    { Header: 'Debit (USD)', accessor: 'debit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Credit (USD)', accessor: 'credit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.75, },
  ]
};

export const undoDepositClearTable: TableSettings = {
  tableVersion: 10037,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Deposit Date', accessor: 'depositDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Received From', accessor: 'receivedFromName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Customer', accessor: 'customerName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Check #', accessor: 'checkNo', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Undo', accessor: 'isSelected', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const cancelCheckClearTable: TableSettings = {
  tableVersion: 10038,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Clear Date', accessor: 'depositDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Vendor', accessor: 'customerName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Check #', accessor: 'checkNo', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: true,visible: true,  initialWidthPercentage: 11.53, },
    { Header: 'Clear', accessor: 'isSelected', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const cancelCreditCardClearTable: TableSettings = {
  tableVersion: 10038,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'CC Clear Date', accessor: 'depositDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Vendor', accessor: 'vendorName', resizable: true, sortable: true, visible: true, initialWidthPercentage: 20.51, },
    { Header: 'CC Ref. #', accessor: 'ccRefNo', resizable: true, sortable: true, visible: true, initialWidthPercentage: 14.10, }, 
    { Header: 'CUR', accessor: 'currency', resizable: true, sortable: true, visible: true, initialWidthPercentage: 5.12, }, 
    { Header: 'Items', accessor: 'items', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: true, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Cancel', accessor: 'isSelected', resizable: true, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: true, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const checkClearWithExcelTable: TableSettings = {
  tableVersion: 10012,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Bank Date', accessor: 'bankDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Bank Amount', accessor: 'bankAmount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Deposit Date', accessor: 'depositDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 20.51, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Confirm', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const paymentToolList: TableSettings = {
  tableVersion: 1045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.3,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.15,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.37,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.96,
    },
    {
      Header: `AR (Bill)`,
      accessor: 'billAmtAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'AR (Due)',
      accessor: 'dueAmtAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'AP (Bill)',
      accessor: 'billAmtAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'AP (Due)',
      accessor: 'dueAmtAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Duty AR (Bill)',
      accessor: 'billAmtDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'Duty AR (Due)',
      accessor: 'dueAmtDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Duty AP (Bill)',
      accessor: 'billAmtDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'Duty AP (Due)',
      accessor: 'dueAmtDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: '',
      accessor: 'isSelect',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
  ]
};

export const periodLoadStorageItem :TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: true,

  alternateRows: false,
  headersColor: 'white',
  columns: [
    {
      Header: 'Select',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Product Code / SKU',
      accessor: 'itemNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 40.27,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.40,
    },
  ]
};

export const emailOptionItem: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: 'Email',
      accessor: 'email',
      resizable: true,
      sortable: false,
      visible: true,
      width: 650,
    },
    {
      Header: 'Select',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      width: 40,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      width: 30,
    },
  ]
};



export const autoBillingDetailTable: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.09,
    },
    {
      Header: 'Company Name',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.24,
    },
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.00,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Last Amount',
      accessor: 'lastAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'A/R',
      accessor: 'ar',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Inv. Seq',
      accessor: 'invoiceSeq',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};



export const autoInvoiceDetailTable: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.09,
    },
    {
      Header: 'Customer',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 50.76,
    },
    {
      Header: 'Invoice Seq',
      accessor: 'invoiceSeq',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.74,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.74,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};
